<template>
    <div class="d-flex fill-height grey lighten-5 of-y b2">

        <div class="pl-2 py-2 fill-height flex-grow-0 d-flex flex-column" style="min-width: 320px;">
            <v-card class="white of-y-f">
                <div class="flex-grow-0 px-2 pt-2 primary--text text-subtitle-2 d-flex align-center">
                    <div class="flex-grow-1">
                        Select Date
                    </div>
                    <v-btn
                            small
                            icon
                            color="secondary"
                            @click="getViewData()"
                    >
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </div>

                <div class="flex-grow-0">
                    <v-menu open-on-hover bottom offset-y nudge-top="5" :close-on-content-click="false" max-width="300">
                        <template v-slot:activator="{on}">
                            <div class="d-flex align-center">
                                <v-btn
                                        icon
                                        color="primary"
                                        class="pa-0"
                                        @click="viewStart = subDays(viewStart, 1); getViewData()"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-text-field
                                        prepend-inner-icon="mdi-calendar"
                                        readonly
                                        color="primary"
                                        dense
                                        hide-details
                                        v-model="startDateModel"
                                        v-on="on"
                                        outlined
                                        class="flex-grow-1"
                                />
                                <v-btn
                                        icon
                                        color="primary"
                                        class="pa-0"
                                        @click="viewStart = addDays(viewStart, 1); getViewData()"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </div>
                        </template>
                        <v-date-picker
                                full-width
                                class="flex-grow-0"
                                v-model="startDateModel"
                                @input="getViewData(true);"
                                no-title
                                :elevation="1"
                        >
                        </v-date-picker>
                    </v-menu>
                </div>

                <div class="flex-grow-0 px-2 pt-2 primary--text text-subtitle-2 d-flex align-center">
                    <div class="flex-grow-1">
                        Device Sync Notifications
                    </div>
                </div>

                <div class="px-4 d-flex justify-center">
                    <v-btn
                            small
                            outlined
                            color="primary"
                            @click="$store.state.showSyncNotifications = !$store.state.showSyncNotifications"
                    >
                        {{$store.state.showSyncNotifications ? 'Hide Sync Notifications' : 'Show Sync Notifications'}}
                    </v-btn>
                </div>

                <div class="flex-grow-1">
                    <multi-select-list
                            :items="availableFarms"
                            itemKey="id"
                            :showCheckBoxes="true"
                            :multiple="false"
                            headlineKey="description"
                            v-model="farmFilter"
                            filterLabel="Filter Farms"
                    >
                        <div slot="header" class="px-2 pt-2 primary--text text-subtitle-2">
                            Filter By Farm
                        </div>
                        <template v-slot:action="{value}">
                            <v-tooltip right>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            x-small
                                            text
                                            icon
                                            @click="exportDownload(value.id)"
                                            color="grey lighten-1"
                                            v-on="on"
                                    >
                                        <v-icon>mdi-download</v-icon>
                                    </v-btn>
                                </template>
                                Donkerhoek Export
                            </v-tooltip>
                        </template>
                    </multi-select-list>
                </div>
            </v-card>
        </div>


        <div class="fill-height flex-grow-1 d-flex align-center justify-center" v-if="loadingData">
            <loader/>
        </div>
        <div class="fill-height flex-grow-1 pa-2" v-else style="overflow-x: auto; width: 100%">
            <v-card class="fill-height of-y">

                <v-tabs
                        :vertical="true"
                        class="fill-height of-y fullTabs"
                        v-model="$store.empCode"
                >
                    <v-tab class="left-tab">
                        <v-icon left>mdi-tractor-variant</v-icon>
                        Farm Summary
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-finance</v-icon>
                        Daily Report
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-clock-alert-outline</v-icon>
                        Absconders
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-clock-alert-outline</v-icon>
                        Latecomers
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-calendar-week</v-icon>
                        Weekly Report
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-account</v-icon>
                        Results Report
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-archive</v-icon>
                        Bin Intake
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-archive-clock</v-icon>
                        Bin Trace
                    </v-tab>

                    <v-tab class="left-tab">
                        <v-icon left>mdi-archive-alert</v-icon>
                        Bin Anomalies
                    </v-tab>

                    <v-tab class="left-tab">
                        <v-icon left>mdi-package-variant</v-icon>
                        Picking Report
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-account-group</v-icon>
                        Employee Detail
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-map-marker</v-icon>
                        Picking Map
                    </v-tab>
                    <v-tab class="left-tab">
                        <v-icon left>mdi-account-alert</v-icon>
                        Warrants
                    </v-tab>
                  <v-tab class="left-tab">
                    <v-icon left>mdi-alert</v-icon>
                    Warnings
                  </v-tab>
                  <v-tab class="left-tab">
                    <v-icon left>mdi-account-remove</v-icon>
                    Under Performers
                  </v-tab>
                  <v-tab class="left-tab">
                    <v-icon left>mdi-account-remove</v-icon>
                    Under Performers HT
                  </v-tab>
                  <v-tab class="left-tab">
                    <v-icon left>mdi-clock-digital</v-icon>
                    Shifts
                  </v-tab>
                    <v-tab-item class="fill-height">
                        <v-card flat class="fill-height">
                            <farm-summary
                                    v-if="reportData && reportData.farmSummary"
                                    :data="reportData.farmSummary"
                                    :selected-farm="farmFilter"
                                    :selected-date="viewStart"
                            />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <daily-view
                                    v-if="reportData && reportData.daily"
                                    :data="reportData.daily"
                                    :selected-farm="farmFilter"
                                    :selected-date="viewStart"
                            />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <absconders-view
                                    v-if="reportData && reportData.absconders"
                                    :data="reportData.absconders"
                                    :selected-farm="farmFilter"
                                    :selected-date="viewStart"
                            />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <late-comers-view
                                    v-if="reportData && reportData.lateComers"
                                    :data="reportData.lateComers"
                                    :selected-farm="farmFilter"
                                    :selected-date="viewStart"
                            />
                        </v-card>
                    </v-tab-item>
                    <v-tab-item class="">
                        <div class="fill-height d-flex align-stretch">
                            <div class="pl-1">
                                <v-divider vertical class="fill-height"></v-divider>
                            </div>
                            <div class="fill-height flex-grow-1">
                                <weekly-report
                                        v-bind:view-start.sync="viewStart"
                                        :selected-farm="farmFilter"
                                        :selected-date="viewStart"
                                />
                            </div>
                        </div>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <results-view
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <bin-intake-view
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <bin-trace-view
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <bin-anomalies-view
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <picking-view
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <employee-detail
                                    :selected-farm="farmFilter"
                                    :selected-date.sync="viewStart"
                            />
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <picking-map
                                :selected-farm="farmFilter"
                                :selected-date.sync="viewStart"
                            ></picking-map>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item class="">
                        <v-card class="fill-height">
                            <warnings-outstanding
                                :selected-farm="farmFilter"
                            ></warnings-outstanding>
                        </v-card>
                    </v-tab-item>

                    <v-tab-item style="overflow-x: auto; width: 100%">
                        <v-card class="fill-height">
                            <warnings-complete
                                :selected-farm="farmFilter"
                            ></warnings-complete>
                        </v-card>
                    </v-tab-item>
                  
                  <v-tab-item style="overflow-x: auto; width: 100%">
                    <v-card class="fill-height">
                      <under-performers :selected-farm="farmFilter" :selected-date.sync="viewStart"/>
                    </v-card>
                  </v-tab-item>
                  
                  <v-tab-item style="overflow-x: auto; width: 100%">
                    <v-card class="fill-height">
                      <under-performers-h-t :selected-farm="farmFilter" :selected-date.sync="viewStart"/>
                    </v-card>
                  </v-tab-item>
                  
                  
                  
                  <v-tab-item class="fill-height">
                    <v-card flat class="fill-height">
                      <shift-values
                          :selected-farm="farmFilter"
                          :selected-date="viewStart"
                      />
                    </v-card>
                  </v-tab-item>
                </v-tabs>

            </v-card>
        </div>


    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {addDays, differenceInHours, differenceInMinutes, format, parse, subDays} from "date-fns";
import Loader from "../General/Loader/Loader";
import MultiSelectList from "../General/Multi Select List/MultiSelectList";
import DashboardReportItem from "./dashboardReportItem";
import DailyView from "./DailyView";
import FarmSummary from "./FarmSummary";
import AbscondersView from "./AbscondersView";
import LateComersView from "./LateComersView";
import WeeklyReport from "./WeeklyReport";
import ResultsView from "./ResultsView";
import BinIntakeView from "./BinIntakeView";
import BinTraceView from "./BinTraceView";
import PickingView from "./PickingView";
import EmployeeDetail from "./EmployeeDetail";
import BinAnomaliesView from "./BinAnomaliesView";
import PickingMap from "@/components/Reports/PickingMap";
import WarningsOutstanding from "@/components/Reports/WarningsOutstanding.vue";
import WarningsComplete from "@/components/Reports/WarningsComplete.vue";
import UnderPerformers from "@/components/Reports/UnderPerformers.vue";
import UnderPerformersHT from "@/components/Reports/UnderPerformersHT.vue";
import ShiftValues from "@/components/Reports/ShiftValues.vue";

export default {
    components: {
      ShiftValues,
      UnderPerformers,
      UnderPerformersHT,
        WarningsComplete,
        WarningsOutstanding,
        PickingMap,
        BinAnomaliesView,
        PickingView,
        BinTraceView,
        BinIntakeView,
        ResultsView,
        WeeklyReport,
        LateComersView, AbscondersView, FarmSummary, DailyView, DashboardReportItem, MultiSelectList, Loader, EmployeeDetail},
    props: {},
    data() {
        return {
            loadingData: false,
            viewStart: new Date(),
            viewEnd: new Date(),
            reportData: null,
            farmFilter: null,
            sorter: 1,
            orderAsc: true,
            addDays: addDays,
            subDays: subDays,
        }
    },
    watch: {
    },
    mounted() {
        this.viewStart = subDays(new Date(), 1);
        this.viewEnd = subDays(new Date(), 1);
        this.getViewData();
    },
    methods: {

        exportDownload(farmID) {

            this.$newReqDownloadFile("POST", `reports/dataExport`, {date: format(this.viewStart, 'yyyy-MM-dd'), farm: farmID}, 'SupaScaleInput.txt')

            // this.$newReq('POST', `reports/dataExport`, {date: format(this.viewStart, 'yyyy-MM-dd'), farm: farmID})
            //     .then((data) => {
            //
            //         // var reportData = `data:text/csv;charset=utf-8,${String.fromCharCode(21)}${data.map((row, i) => {return `${i+1},${row.deviceID},${row.farmID},${row.activityID},${row.clockMode},${row.empID},${row.binsUnits},${row.date},${row.time},\n`}).join('')}${String.fromCharCode(21)}`
            //         // var encodedUri = encodeURI(reportData);
            //         // var link = document.createElement("a");
            //         // link.setAttribute("href", encodedUri);
            //         // link.setAttribute("download", "SupaScaleInput.txt");
            //         // document.body.appendChild(link); // Required for FF
            //         // link.click();
            //         // // document.removeChild(link)
            //     })
                .catch(e => {
                    console.log(e)
                })
        },

        sorterClicked(index) {
            if (this.sorter === index)
                this.orderAsc = !this.orderAsc
            else
                this.sorter = index
        },

        getViewData(viewStartOnly = false) {
            if (viewStartOnly)
                this.viewEnd = this.viewStart
            this.reportData = [];
            this.loadingData = true;
            this.$newReq('POST', `reports/allReports`, {start: format(this.viewStart, 'yyyy-MM-dd'), end: format(this.viewEnd, 'yyyy-MM-dd')})
                .then(data => {

                    const daily = data.daily.map(obj => {
                        const res = {
                            ...obj,
                            farm: this.farmsRef[obj.fkFarm],
                            emp: this.empRef[obj.fkEmp],
                            clockInStr: obj.clockedIn ? format(new Date(obj.clockedIn), 'yyyy-MM-dd HH:mm') : null,
                            rollCalledStr: obj.rollCalled ? format(new Date(obj.rollCalled), 'yyyy-MM-dd HH:mm') : null,
                            lastActionStr: obj.lastAction && obj.lastAction !== '0' ? format(new Date(obj.lastAction), 'yyyy-MM-dd HH:mm') : '-',
                            pieceWorkStr: obj.pieceWorkTypes.length ? obj.pieceWorkTypes.map(pwt => {
                                return this.piece_workRef[pwt] ? this.piece_workRef[pwt].description : '-'
                            }).join(', ') : '-'
                        }
                        // Format The Hours Here

                        res.hours = obj.lastAction && obj.lastAction !== '0' ? Math.round( (
                                (differenceInMinutes(new Date(obj.lastAction), new Date(obj.clockedIn)) + 1) / 60
                        ) * 100) / 100
                                : 0;

                        return res
                    })

                    const farmSummary = data.farmSummary.map(obj => {
                        return {
                            ...obj,
                            farmRef: this.farmsRef[obj.farmID]
                        }
                    })

                    const absconders = data.absconders.map(obj => {
                        return {
                            ...obj,
                            farmRef: this.farmsRef[obj.fkFarm],
                            empRef: this.empRef[obj.fkEmp],
                            lastCheckIn: obj.lastCheckIn ? format(new Date(obj.lastCheckIn), 'yyyy-MM-dd HH:mm') : null
                        }
                    })

                    const lateComers = data.lateComers.map(obj => {
                        return {
                            ...obj,
                            farmRef: this.farmsRef[obj.fkFarm],
                            empRef: this.empRef[obj.fkEmp],
                            checkIn: obj.captured ? format(new Date(obj.captured), 'yyyy-MM-dd HH:mm') : null
                        }
                    })

                    this.reportData = {
                        daily,
                        farmSummary,
                        absconders,
                        lateComers
                    }
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.loadingData = false;
                })
        }
    },
    computed: {
        ...mapGetters(["user", "farms", "farmsRef", "availableFarms", "empRef", "piece_workRef"]),
        startDateModel: {
            get() {
                return format(this.viewStart, 'yyyy-MM-dd')
            },
            set(val) {
                this.viewStart = parse(val, 'yyyy-MM-dd', new Date());
            }
        },
    },
}
</script>

<style>
    .t-b {
        border-right: 1px solid rgba(0,0,0, 0.1);
    }
    .t-b-b {
        border-bottom: 1px solid rgba(0,0,0, 0.1);
    }
</style>